var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.9 23.1",
    style: {
      enableBackground: "new 0 0 23.9 23.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2F3061;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_icon",
    transform: "translate(-640.025 -583.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.5,
    y: 582.4,
    transform: "matrix(0.6878 -0.7259 0.7259 0.6878 -228.7152 659.2578)",
    className: "st0",
    width: 7,
    height: 26.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.8,
    y: 592,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -230.2583 635.1849)",
    className: "st0",
    width: 25.5,
    height: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.61d1d8a995a0d910dd7e3d9851edd7f9.svg";
export { ForwardRef as ReactComponent };